// extracted by mini-css-extract-plugin
module.exports = {"brandListGroupWrapper":"YRNg62mjEBRYE9XZvvYlm","brandListGroupItemWrapper":"_3QIQZ69xH9y-4EI1bS6Eo3"};